module.exports = __webpack_public_path__ + "static/img/BH.4322f2ef.png";